import { CSSProperties, FC } from 'react'
import StockImageThumb from './StockImageThumb'

export type SafeProductImageProps = {
  src?: string | null
  alt?: string
  className?: string
  style?: CSSProperties
}

/** รูปสินค้า/สต็อก — fallback No Image เมื่อไม่มี URL หรือโหลดไม่สำเร็จ */
export const SafeProductImage: FC<SafeProductImageProps> = ({
  src,
  alt = '',
  className,
  style,
}) => (
  <div
    className={className}
    style={{
      overflow: 'hidden',
      background: '#f5f5f5',
      flexShrink: 0,
      ...style,
    }}
  >
    <StockImageThumb src={src} alt={alt} />
  </div>
)

export default SafeProductImage
